/**
 * Backbone view which provides editor functionality for a 'button' field type.
 * ## Fields
 * The `value` field gets and sets the current value.
 * ## Events
 * The `'change'` event is raised whenever the value changes. The event has a single argument, the new value.
 * @module app/Field/ButtonEditor
 */
import BaseListView from "core/views/Field/BaseListView";
import _ from "underscore";
import ButtonView from "core/views/ButtonView";
export default BaseListView.extend({
  className: "button-bar",

  template: _.template(
    '<input type="hidden" name="<%= name%>" class="button-selection" value="<%= value%>"/>'
  ),
  itemTemplate: function (item) {
    var self = this;
    var view = new ButtonView({
      text: item.text,
      click: function () {
        self.setControlValue(item.value);

        self.onChange();
      },
    });

    view.render();

    return view.$el;
  },

  insertItem: function (item) {
    this.$el.append(item);
  },

  getControlValue: function () {
    return this.$(".button-selection").val();
  },

  setControlValue: function (value) {
    this.$(".button-selection").val(value);
  },

  serialize: function () {
    return {
      name: this.field.id,
      value: this.getValue(""),
    };
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/edit/ButtonEditor.js
// module id = 837
// module chunks = 1